<template>
  <div
    class="modal fade"
    id="ModalEditBaseUsePlace"
    tabindex="99"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-notify modal-info" role="document">
      <!--Content-->
      <div class="modal-content text-center">
        <!--Header-->
        <div class="modal-header d-flex justify-content-center">
          <p class="heading">ویرایش مرکز هزینه</p>
        </div>

        <!--Body-->
        <div class="modal-body px-4 py-2" style="height: 100%; overflow: auto">
          <div class="row my-3">
            <!-- کادر کد مرکز هزینه -->
            <div class="col-12 position-relative">
              <input
                type="text"
                placeholder="کد مرکز هزینه"
                class="form-control text-center mt-2"
                v-model="BaseUsePalce.NCode"
                autocomplete="off"
                style="direction: ltr"
                maxlength="9"
                disabled
              />
              <i
                class="
                  fas
                  fa-qrcode fa-1x-half
                  position-absolute
                  iconStyle
                  MandatoryStyle
                "
                title="کد مرکز هزینه"
                style="top: 25%"
              ></i>
            </div>
            <!-- کادر نام مرکز هزینه -->
            <div class="col-12 position-relative">
              <input
                type="text"
                placeholder="نام مرکز هزینه"
                class="form-control text-center mt-2"
                v-model="BaseUsePalce.SDesc"
                autocomplete="off"
                style="direction: rtl"
                maxlength="50"
              />
              <i
                class="
                  far
                  fa-comment fa-1x-half
                  position-absolute
                  iconStyle
                  MandatoryStyle
                "
                title="نام مرکز هزینه"
                style="top: 25%"
              ></i>
            </div>
          </div>
        </div>

        <!--Footer-->
        <div class="modal-footer flex-center justify-content-between px-4" style="height: 15%">
          <a
            class="btn btn-info waves-effect waves-light"
            v-bind:class="checkConnectToServer ? 'disabled btn-pink': ''"
            v-on:click="EditBaseUsePlace()"
            >
            <i v-if="checkConnectToServer" class="fas fa-sync fa-spin fa-1x ml-2"></i>
            ویرایش مرکز هزینه
            </a>
          <a
            class="btn btn-outline-info waves-effect waves-light"
            v-bind:class="checkConnectToServer ? 'disabled': ''"
            style="padding-top: 0.375rem; padding-bottom: 0.375rem"
            data-dismiss="modal"
            >انصراف</a
          >
        </div>
      </div>
      <!--/.Content-->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // اطلاعات شخصیت
      BaseUsePalce: {
        NCode: "", // کد مرکز هزینه
        SDesc: "", // نام مرکز هزینه
        NUserCode: 0, // کد کاربر
        SDate: "", // تاریخ ایجاد
        DTime: "",
      },
      // کنترل اتصال به سرور
      checkConnectToServer: false,
    };
  },
  props: ["GetBaseUsePlace"],
  watch:{
    GetBaseUsePlace: function(value){
        this.BaseUsePalce.NCode = value.NCode;
        this.BaseUsePalce.SDesc = value.SDesc;
        this.BaseUsePalce.NUserCode = value.NUserCode;
        this.BaseUsePalce.SDate = value.SDate;
        this.BaseUsePalce.DTime = value.DTime;
    }
  },
  computed: {},
  methods: {
    // ذخیره مرکز هزینه جدید
    async EditBaseUsePlace() {
      // آیا کد مرکز مقدار دهی شده است ؟
      if (this.BaseUsePalce.NCode != "") {
        // آیا نام مرکز هزینه ثبت شده است ؟
        if (this.BaseUsePalce.SDesc != "") {
          let ListBaseUsePlace = this.$store.getters.getTbBaseUsePlaceData;
          let index = ListBaseUsePlace.findIndex(
            (item) => item.NCode == this.BaseUsePalce.NCode && item.NCode != this.GetBaseUsePlace.NCode
          );
          if (index != -1) {
            // کد درج شده تکراری است
            swal({
              title: "کد درج شده تکراری است !",
              text:
                "کد درج شده قبلا برای مرکز هزینه (" +
                ListBaseUsePlace[index].SDesc +
                ") استفاده شده است .",
              icon: "info", // success, warning, error, info
              buttons: {
                cancel: "متوجه شدم",
              },
            });
          } else {
            // اعلام اتصال به سرور
            this.checkConnectToServer = true;
            // دریافت توکن احراز هویت
            let token = await this.$store.getters.getUserData.token;
            // ثبت شخصیت جدید در سرور
            await this.$store.dispatch("EditBaseUsePlaceToServer", {
              BaseUsePalce: this.BaseUsePalce,
              token: token,
            });
            // بستن مودال ثبت مرکز هزینه جدید
            $("#ModalEditBaseUsePlace").modal("hide");
          }
        } else {
          // ثبت نام مرکز الزامی است
          this.$store.dispatch("notify", {
            notText: "عدم درج نام مرکز هزینه : درج نام مرکز هزینه الزامی است !",
            timeOut: 2500,
          });
        }
      } else {
        // ثبت کد مرکز هزینه الزامی است
        this.$store.dispatch("notify", {
          notText: "عدم درج کد مرکز هزینه : درج کد مرکز هزینه الزامی است !",
          timeOut: 2500,
        });
      }
      // لغو اعلام اتصال به سرور
      this.checkConnectToServer = false;
    },
  },
};
</script>

<style>
/* استایل آیکون کنار فیلدها */
.iconStyle {
  top: 18%;
  right: 0px;
  border-radius: 50%;
  background-color: #e6f2fd;
  border: 1px solid #ced4da;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/* استایل فیلدهای اجباری */
.MandatoryStyle {
  background-color: #fde6e6;
}
/* استایل انتخاب سطر */
.selectStyle {
  font-size: 12px;
  height: 38px;
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/ListBaseUsePlace/Components/EditBaseUsePlace.vue